import { PsaQueryKeys } from "components/PSA/queryKeys";
import { useTypedQuery } from "hooks";
import { ApiInstance } from "utils/Api";

export const useCarWidget = (car_id: number, enabled: boolean) =>
  useTypedQuery({
    queryKey: PsaQueryKeys.carWidget,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { car_id }, baseUrl))?.data ?? null,
    enabled
  });
